import { message } from 'antd';
import { mapSnakeCaseToSpaceCase } from './mapper';
export const displayError = (error: any): void => {
  // Handle plain string passed directly
  if (typeof error === 'string') {
    message.error(error);
    return;
  }

  // Handle field-level errors: { data: { errors: { field: ["msg"] } } }
  const fieldErrors = error?.data?.errors;
  if (fieldErrors && typeof fieldErrors === 'object') {
    Object.keys(fieldErrors).forEach((key) => {
      const value = fieldErrors[key];
      if (Array.isArray(value)) {
        message.error(`${mapSnakeCaseToSpaceCase(key)} - ${value.join(', ')}`);
      } else if (typeof value === 'string') {
        message.error(`${mapSnakeCaseToSpaceCase(key)} - ${value}`);
      }
    });
    return;
  }

  // Handle legacy error format: { data: { error: ... } }
  const errorData = error?.data?.error;
  if (errorData) {
    if (typeof errorData === 'string') {
      message.error(errorData);
    } else {
      const { details, message: errorMessage } = errorData;

      if (details && typeof details === 'object' && details !== null) {
        Object.keys(details).forEach((key) => {
          if (
            typeof details[key] === 'object' &&
            !Array.isArray(details[key])
          ) {
            Object.keys(details[key]).forEach((subKey) => {
              message.error(
                `${mapSnakeCaseToSpaceCase(key)}.${mapSnakeCaseToSpaceCase(subKey)} - ${details[key][subKey].join(', ')}`,
              );
            });
          } else {
            message.error(
              `${mapSnakeCaseToSpaceCase(key)} - ${details[key].join(', ')}`,
            );
          }
        });
      } else if (errorMessage) {
        message.error(errorMessage);
      } else {
        message.error('An unexpected error occurred');
      }
    }
    return;
  }

  // Handle { data: { message: "..." } }
  if (error?.data?.message) {
    message.error(error.data.message);
    return;
  }

  message.error('An error occurred with no additional information provided.');
};

export const displaySuccess = (successMsg: any = 'Successfull'): void => {
  message.success(successMsg);
};

export const displayWarning = (warningMsg: any = 'Warning'): void => {
  message.warning(warningMsg);
};
export const displayInfo = (infoMsg: any = 'Info'): void => {
  message.info(infoMsg);
};
export const displayErrorText = (errorMsg: any = 'Error'): void => {
  message.error(errorMsg);
};
